@let system = (system$ | async); @if (visible && system) {
<div
  class="absolute top-8 left-8 w-[300px] bg-white rounded-lg shadow-md z-[1000] overflow-hidden px-8"
  style="animation: fadeIn 0.2s ease-in"
>
  <div class="px-8 pt-8 flex items-center justify-between">
    <p class="m-0 text-lg font-semibold">{{ system.systemName }}</p>

    <div class="flex items-center gap-12">
      <button
      (click)="navigate(system.id, 'storage-hierarchy')"
      nz-popover
      nzPopoverContent="Hierarchy Diagram"
      nzPopoverPlacement="top"
      class="flex items-center justify-center"
    >
      <twaice-fe-svg-icon source="tabler" name="tournament" width="14px" height="14px" />
    </button>
      <button
        (click)="openChat(system.customerBk, system.systemBk, system.systemName)"
        nz-popover
        nzPopoverContent="System Notes"
        nzPopoverPlacement="top"
        class="flex items-center justify-center"
      >
        <nz-badge [nzDot]="system.newChatMessagesAvailable">
          <twaice-fe-svg-icon source="tabler" name="messages" width="16px" height="16px" />
        </nz-badge>
      </button>
    </div>
  </div>

  <nz-divider class="my-8" />

  <div class="px-8">
    <twaice-fe-system-live-kpis [system$]="system$" [visible]="visible" />
  </div>

  <nz-divider class="my-8" />

  <div class="px-8 mb-8">
    <span class="details-data text-xs text-secondary-text leading-[20px]">{{ getStorageLocation(system.bessMetadata) }}</span>

    <div class="flex items-center gap-8 text-xs">
      <span class="text-tertiary-text text-xs leading-lg w-64">{{
        system?.bessMetadata?.nameplateEnergyCapacityMwh
          ? (system?.bessMetadata?.nameplateEnergyCapacityMwh | number: '1.0-0') + ' MWh'
          : '--'
      }}</span>
      <span class="border-l-1 h-16 w-1 p-4"></span>
      <span class="text-tertiary-text text-xs leading-lg w-64">{{
        system?.bessMetadata?.nameplatePowerMw ? (system?.bessMetadata?.nameplatePowerMw | number: '1.0-0') + ' MW' : '--'
      }}</span>
    </div>
  </div>
</div>
}
